import { ChefHat } from "lucide-react";

export const Header = () => (
  <div className="flex flex-col items-center gap-4 text-center rs-fade">
    <div className="flex h-16 w-16 items-center justify-center rounded-full bg-[#d7352b] text-white shadow-[0_10px_24px_-10px_rgba(215,53,43,0.8)]">
      <ChefHat size={32} strokeWidth={2.2} />
    </div>
    <h1 className="rs-display text-4xl font-extrabold leading-tight sm:text-5xl" data-testid="app-title">Recipe Remedy</h1>
    <p className="rs-secondary -mt-2 max-w-[380px] text-base md:text-lg" data-testid="app-subtitle">
      Save recipe Reels &amp; TikToks from your favorite chefs, sorted by cuisine, meal and diet.
    </p>
  </div>
);
